import { useQuery } from "@tanstack/react-query";
import { GET_CITIES } from "@/constants/Query";
import { apiRequest } from "@/utils/apiRequest";
import { ICity } from "@/types/apiResponse.types";
import { useTheme } from "@/context/Theme.context";
import { Theme } from "@/enums";

export const useGetCitiesRequest = ({
  regionId,
  firstLettersCityName,
}: {
  regionId: string;
  firstLettersCityName: string;
}) => {
  const theme = useTheme();

  return useQuery<{
    data: {
      data: ICity[];
    };
  }>({
    queryKey: [GET_CITIES, regionId, firstLettersCityName, theme],
    queryFn: () =>
      apiRequest(GET_CITIES, "get", {
        regionId,
        firstLettersCityName,
      }),
    enabled: !!regionId || theme === Theme.GEORGIA,
  });
};
